import React, { Component } from 'react'
import style from './style.module.css'

import appConfig from '../../core/services/appConfig'

class LoginSalesforce extends Component {
  loginSalesforce = () => {
    this.props.setLoading(true)
    const { salesforceClientId, salesforceOauthUrl } = appConfig

    const params = new URLSearchParams({
      client_id: salesforceClientId,
      redirect_uri: `${window.location.origin}/`,
      response_type: 'code'
    })

    window.open(`${salesforceOauthUrl}/services/oauth2/authorize?${params.toString()}`, '_self')
  }

  render = () => (
    <div>
      <input
        type="submit"
        className={style.login__button}
        onClick={this.loginSalesforce}
        disabled={this.props.isLoading}
        value="Login Salesforce"
      />
    </div>
  )
}

export default LoginSalesforce
